// extracted by mini-css-extract-plugin
export default {"easy":"Easy_easy__4arNo","list":"Easy_list__zEN8E","sec":"Easy_sec__+zQ60","iconWrpr":"Easy_iconWrpr__iQviV","filterBy":"Easy_filterBy__g8+kS","bar":"Easy_bar__auV8I"};